import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { KeyboardTypeOptions, StyleSheet, Text, View } from 'react-native';

import CodeInput from './CodeInput';

export type CodeInputFieldProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label?: string;
  keyboardType?: KeyboardTypeOptions;
};

const CodeInputField = <T extends FieldValues>({ name, control, label, keyboardType }: CodeInputFieldProps<T>) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { value, onChange }, fieldState: { error } }) => (
      <View style={styles.mainContainer}>
        {label && <Text style={styles.labelText}>{label}</Text>}
        <CodeInput value={value} setValue={(value) => onChange(value)} keyboardType={keyboardType} />
        {error?.message !== undefined ? <Text style={styles.errorText}>{error?.message}</Text> : <></>}
      </View>
    )}
  />
);

const styles = StyleSheet.create({
  mainContainer: {
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 10
  },

  labelText: {
    fontSize: 14,
    fontWeight: '400',
    flex: 1
  },

  errorText: {
    color: 'red',
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10
  }
});

export default CodeInputField;
